module.exports = "<h4>Bienvenido(a) a la administración de {{ empresaNombre }} v{{ version }}</h4>\r\n"